import { LessonDetails } from "./LessonDetails";

export default LessonDetails;
